import { pathTo } from '@/plugins/router/helper';

export const accountItems = [
  {
    title: 'Account',
    icon: 'account_circle',
    id: 'account',
    path: pathTo.account,
  },
  {
    title: 'Settings',
    icon: 'settings',
    id: 'settings',
    path: pathTo.settings,
  },
  {
    title: 'Language',
    icon: 'language',
    id: 'language',
    path: pathTo.language,
  },
  {
    title: 'Logout',
    icon: 'logout',
    id: 'logout',
  },
];

export const noAuthItems = [
  {
    title: 'Language',
    icon: 'language',
    id: 'language',
    path: pathTo.language,
  },
  {
    title: 'Login',
    icon: 'mdi-login',
    id: 'login',
    path: pathTo.login,
  },
];

export const menuItems = [
  {
    title: 'Home',
    icon: 'home',
    path: pathTo.home,
  },
  {
    title: 'Learn',
    icon: 'school',
    path: pathTo.learn,
  },
  {
    title: 'MyVocabulary',
    icon: 'view_list',
    path: pathTo.my_vocabulary,
  },
  {
    title: 'Admin',
    icon: 'verified_user',
    path: pathTo.admin,
    role: 'admin',
  },
];

export const additionalItems = [
  {
    title: 'Dataprivacy',
    icon: 'remove',
    path: pathTo.dataprivacy,
  },
  {
    title: 'Imprint',
    icon: 'remove',
    path: pathTo.imprint,
  },
];
